import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as HolidayActions from '~/repositories/holiday/store/holiday.actions';
import { HolidayEntity } from '~/repositories/holiday/store/holiday.models';

export interface HolidayState extends EntityState<HolidayEntity> {
  loading?: boolean;
  error?: string | null;
  selectedYear: number;
  availableYears: number[];
}

export const holidayAdapter: EntityAdapter<HolidayEntity> = createEntityAdapter<HolidayEntity>();
export const initialHolidayState: HolidayState = holidayAdapter.getInitialState({
  loading: false,
  selectedYear: new Date().getFullYear(),
  availableYears: Array.from({ length: 4 }, (_, index) => {
    return new Date().getFullYear() + index - 1;
  })
});

const reducer = createReducer(
  initialHolidayState,
  on(HolidayActions.fetchHolidays, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(HolidayActions.fetchHolidaysSuccess, (state, { holidays }) =>
    holidayAdapter.setAll(holidays, {
      ...state,
      loading: false
    })
  ),
  on(HolidayActions.fetchHolidaysFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),
  on(HolidayActions.fetchAvailableYears, (state) => ({ ...state })),
  on(HolidayActions.changeSelectedYear, (state, { year }) => ({
    ...state,
    selectedYear: year
  })),
  on(HolidayActions.publishHoliday, (state) => ({
    ...state
  })),
  on(HolidayActions.publishHolidaySuccess, (state, { holiday }) => holidayAdapter.addOne(holiday, state)),
  on(HolidayActions.publishHolidayFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(HolidayActions.deleteHoliday, (state) => ({
    ...state
  })),
  on(HolidayActions.deleteHolidaySuccess, (state, { id }) => holidayAdapter.removeOne(id, state)),
  on(HolidayActions.deleteHolidayFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export function holidayReducer(state: HolidayState, action: Action) {
  return reducer(state, action);
}
